import { Service } from "@front-apps/core/services/Service"
import StoreService from "@front-apps/core/services/store"
import LinkAPI from "../API/link"
import NavigationService from "@front-apps/core/services/navigation"
import GroupService from "@front-apps/core/services/group"
import WebNavigationParamService from "@front-apps/core/services/webNavigationParam"
class DataService extends Service {
    private static instance: DataService

    constructor() {
        super()
        // set le nom du service
        this.name = "DataService"
        // ajoute toute les methodes du service au tableau de mapping
        this.serviceMap = [
            { key: "saveCustomerData", fct: this.saveCustomerData },
            { key: "clearData", fct: this.clearData },
            { key: "getCustomer", fct: this.getCustomer },
            {
                key: "addGroupDataToQRCodeTram",
                fct: this.addGroupDataToQRCodeTram,
            },
            {
                key: "sendBarCodeByEmail",
                fct: this.sendBarCodeByEmail,
            },
            {
                key: "printBarCode",
                fct: this.printBarCode,
            },
            {
                key: "getCurrentActionButtons",
                fct: this.getCurrentActionButtons,
            },
        ]
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): DataService {
        if (!this.instance) {
            this.instance = new DataService()
        }
        return this.instance
    }

    public async saveCustomerData(
        firstName?: string,
        lastName?: string,
        phone?: string,
        email?: string,
        address?: string,
        zipCode?: string,
        city?: string,
        tempAddress?: string,
        partner?: string
    ) {
        try {
            const tramQrCode = `${firstName || ""}:${lastName || ""}:${
                phone || ""
            }:${email || ""}:${address || ""}:${zipCode || ""}:${city || ""}:${
                tempAddress || ""
            }:${partner || ""}`
            await StoreService.getInstance().persistant.set(
                "customer",
                JSON.stringify(tramQrCode)
            )

            await StoreService.getInstance().persistant.set(
                "customerEmail",
                email || "noset"
            )
        } catch (error) {
            console.error(error)
            throw error
        }
    }

    public async clearData() {
        try {
            await StoreService.getInstance().persistant.delete("customer")
            await StoreService.getInstance().persistant.delete("groupTram")
        } catch (error) {
            console.error(error)
            throw error
        }
    }

    public async getCustomer() {
        try {
            const customer = await StoreService.getInstance().persistant.get(
                "customer"
            )
            if (customer) {
                return JSON.parse(customer)
            }
            return null
        } catch (error) {
            console.error(error)
            throw error
        }
    }

    public async sendBarCodeByEmail(
        email: string,
        barCode: string,
        groupId: string,
        pdv?: string | number
    ) {
        try {
            const customer = await StoreService.getInstance().persistant.get(
                "customer"
            )
            const lang = await StoreService.getInstance().persistant.get("lang")
            if (customer) {
                const custom = JSON.parse(customer)
                const customerEmail = custom.split(":")[3]
                const firstName = custom.split(":")[0]
                await LinkAPI.sendBarCodeByEmail(
                    email || customerEmail,
                    firstName,
                    barCode,
                    groupId,
                    pdv ?? 0,
                    lang
                )
            }
            return null
        } catch (error) {
            console.error(error)
            throw error
        }
    }

    public async addGroupDataToQRCodeTram(users: any[]) {
        try {
            const customer = await StoreService.getInstance().persistant.get(
                "customer"
            )

            if (!customer) {
                throw new Error(
                    "Customer data not found in persistent storage."
                )
            }

            const customerData = JSON.parse(customer)
            const [
                firstName,
                lastName,
                phone,
                email,
                address,
                zipCode,
                city,
                tempAddress,
                partner,
            ] = customerData.split(":")

            // Start building the tram string
            let tram = `${firstName};${lastName};${phone};${email};${address};${zipCode};${city};${tempAddress};${partner}`

            users.forEach((user) => {
                const { name, age, weight, height, shoeSize, skiLevel } = user

                tram += `;${name};${age};${weight};${height};${shoeSize};${skiLevel}`
            })

            await StoreService.getInstance().persistant.set("groupTram", tram)
        } catch (error) {
            console.error("Error generating QR Code tram:", error)
            throw error
        }
    }
    public async printBarCode(
        barCode: string,
        firstName: string,
        lastName: string
    ): Promise<void> {
        try {
            const barCodePrint = await LinkAPI.printBarCode(
                barCode,
                firstName,
                lastName
            )
            const barCodeWindow = window.open()
            barCodeWindow?.document.write(barCodePrint)
        } catch (error) {
            console.error(error)
            throw error
        }
    }
    public async getCurrentActionButtons() {
        const webNavigationParam = WebNavigationParamService.getInstance()
        const { params } = webNavigationParam.get()
        let groupId = StoreService.getInstance().local.get("groupId")
        let pdv = StoreService.getInstance().local.get("pdv")

        if (!groupId) {
            groupId = params?.groupId
        }
        if (!pdv) {
            pdv = params?.pdv || 0
        }
        try {
            const groupCheckInSetting =
                await GroupService.getInstance().getSetting("checkIn", groupId)

            // set actionButtons
            const actionButtons =
                groupCheckInSetting?.pdvs[pdv]?.actionButtons || []
            const actionButtonsObject = actionButtons.reduce(
                (acc: any, item: any) => {
                    acc[item._id] = item.show
                    return acc
                },
                {}
            )

            return actionButtonsObject
        } catch (error) {
            console.error("Error fetching action buttons:", error)
            NavigationService.getInstance().navigateTo("error", {
                groupId,
            })
        }
    }
}

export default DataService
